import { render, staticRenderFns } from "./recipients.vue?vue&type=template&id=11e778c0&scoped=true"
import script from "./recipients.vue?vue&type=script&lang=js"
export * from "./recipients.vue?vue&type=script&lang=js"
import style0 from "./recipients.vue?vue&type=style&index=0&id=11e778c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e778c0",
  null
  
)

export default component.exports